import React from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {IconoirCustomEstimate} from '@ey/motif-react-wrapper/assets/icons/custom';
import {toggleFrameModal, useFrameService} from '@ey/canvascoreservices';
import {GuidedWorkflowV2DocumentTypes} from '../../../util/uiconstants';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';
import {labels} from '../../../util/utils';
import AccountExecutionType from '../Accounts/AccountExecutionType/AccountExecutionType';

export default function LinkOpensInDrawer(props) {
	const {
		id,
		name,
		documentName,
		documentType,
		documentExtension,
		engagementId,
		hasEstimate,
		executionTypeId,
		fromTooltip,
		onClick,
		noOfLines = 1
	} = props;
	const frameService = useFrameService();

	const getUrl = () => {
		let returnUrl = '';
		if (GuidedWorkflowV2DocumentTypes.includes(documentType)) {
			returnUrl = new URL(window.location.origin) + `fit?engagementid=${engagementId}&documentid=${id}&isdrawer=true`;
		}
		return returnUrl;
	};

	const openInDrawer = (fullName, docType, id) => {
		if (onClick) {
			onClick();
		}
		if (window.self === window.top) {
			toggleFrameModal({
				isAresView: true,
				variant: 'slideout',
				frameArgs: {
					name: fullName,
					src: getUrl()
				}
			});
		} else {
			frameService.openFrameFromChild({
				isAresView: true,
				variant: 'slideout',
				frameArgs: {
					name: fullName,
					src: getUrl()
				}
			});
		}
	};

	return (
		<SpanThatOpensInDrawer
			id={id}
			className={`link-for-drawer ${executionTypeId ? 'executionVisible' : 'executionNotVisible'}`}
		>
			<span
				className="account-name"
				onClick={(e) => openInDrawer(documentName + '.' + documentExtension, documentType, id)}
			>
				<EllipsesControl content={name} tooltip={name} noOfLines={noOfLines} />
			</span>
			{!fromTooltip && (
				<>
					<AccountExecutionType executionTypeId={executionTypeId} />
					{hasEstimate && (
						<MotifIcon
							className="medium estimate-icon"
							title={labels.estimate}
							iconFunction={IconoirCustomEstimate}
							size="24"
						/>
					)}
				</>
			)}
		</SpanThatOpensInDrawer>
	);
}

const SpanThatOpensInDrawer = styled.span`
	display: flex;
	color: var(--blue-600);
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-24);
	.account-name {
		cursor: pointer;
		display: inline-flex;
		width: auto;
		max-width: calc(100% - var(--px-100));
		justify-content: flex-start;
		&:hover {
			text-decoration: underline;
		}
	}
	.estimate-icon {
		display: flex;
		justify-content: flex-end;
		margin-left: auto;
		color: var(--neutrals-900);
		svg {
			height: var(--px-24);
			width: var(--px-24);
			color: var(--neutrals-900);
			path {
				fill: currentColor;
			}
		}
	}
	.executionTypeLabel {
		color: var(--neutrals-900);
	}
`;
